import { render, staticRenderFns } from "./label-form.vue?vue&type=template&id=248159ee&lang=pug"
import script from "./label-form.vue?vue&type=script&lang=js"
export * from "./label-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports